<template lang="html">
  <div class="">
    <MarketingSubheader />
    <p>Widgets</p>
    <WidgetsComponent />
  </div>
</template>

<script>
import MarketingSubheader from '../../components/MarketingComponents/MarketingSubheader';
import WidgetsComponent from '../../components/MarketingComponents/WidgetComponent/WidgetsComponent';
export default {
  name: "WidgetsPage",
  components: {
    MarketingSubheader,
    WidgetsComponent
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
